import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import FonbetLogo from 'assets/icons/fonbet/fonbet-logo.png';
import { useMainNavigate, useTranslate } from 'hooks';
import { useAppSelector } from 'store/hooks';
import type { HeaderProps } from 'types';

import { SwitchLocale } from '../../switch-locale';

const Header: FC<HeaderProps> = () => {
  const { t } = useTranslate();
  const navigate = useNavigate();
  const { paymentData } = useAppSelector((state) => state.payment);
  const { goToReturnUrl } = useMainNavigate();

  const back = () => {
    if (paymentData?.returnURL) {
      goToReturnUrl(paymentData.returnURL);
    } else {
      navigate('/');
    }
  };

  return (
    <header className="flex items-center justify-between mx-12 py-2 w-full mb-3 md:mb-0">
      <button
        type="button"
        onClick={back}
        className="md:flex items-center gap-2.5 text-xl md:left-0 w-6 md:w-[200px] hidden"
      >
        <div className="h-3.5 w-3.5 bg-arrow-left md:h-4 md:w-4" />
        <div className="hidden md:block text-base">{t('1xbet.back')}</div>
      </button>
      <div className="text-lg md:text-xl leading-7 font-medium flex-grow text-center">
        <img src={FonbetLogo} className="w-[120px] md:w-[182px] md:mx-auto" alt="1xbet logo" />
      </div>
      <div className="w-6 md:hidden" />
      <div className="md:w-[200px]">
        <SwitchLocale />
      </div>
    </header>
  );
};

export { Header };
